module.exports = __webpack_public_path__ + "img/ereszkalkulator_26_minoseg_premium_fekete.48946717.png";